@import 'core';

/**
 * @prop --ads-tag-background-color: The background color for ads-tag
 * @prop --ads-tag-background-color-active: The background color for ads-tag on active
 * @prop --ads-tag-background-color-focus: The background color for ads-tag on focus
 * @prop --ads-tag-background-color-hover: The background color for ads-tag on hover
 *
 * @prop --ads-tag-border-color: The border color for ads-tag
 * @prop --ads-tag-border-color-active: The border color for ads-tag on active
 * @prop --ads-tag-border-color-focus: The border color for ads-tag on focus
 * @prop --ads-tag-border-color-hover: The border color for ads-tag on hover
 *
 * @prop --ads-tag-color: The border color for ads-tag
 * @prop --ads-tag-color-active: The border color for ads-tag on active
 * @prop --ads-tag-color-focus: The border color for ads-tag on focus
 * @prop --ads-tag-color-hover: The border color for ads-tag on hover
 */

:host {
  display: inline-flex;
  margin: 0;
  padding: 0;
  vertical-align: middle;

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }
}

:host([theme='default']) {
  @include ads-vars-component-tag-default;
}

:host([theme='dark']) {
  @include ads-vars-component-tag-dark;
}

.c-tag {
  @include ads-tag;
  font-size: 14px;
  margin: 0;
}
